import { DiligenceCardFragments } from 'features/deals/dealCards/Diligence/DiligenceCard.fragments';
import { LoansCardFragments } from 'features/deals/dealCards/LoansCard';
import { StratsCardFragments } from 'features/deals/dealCards/StratsCard';
import BiddingAndPricingControllerFragments from 'features/pages/marketplace/BiddingAndPricing/BiddingAndPricingController.fragments';

import { gql } from '@apollo/client';

import BidCardFragments from './BidCardBody/fragments';
import CarveDetailsCardFragments from './CarveDetailsCardBody/fragments';
import CounterpartyCardFragments from './CounterpartyCardBody/fragments';
import DealDocumentsCardFragments from './DealDocumentsCardBody/fragments';
import SettlementCardFragments from './Settlement/fragments';
import WireConfirmationCardFragments from './WireConfirmationCardBody/fragments';

const PlaceholderCardFragments = {
  TimelineCard: gql`
    fragment PlaceholderCard on TimelineCard {
      ... on PlaceholderCard {
        tooltip
      }
    }
  `,
};

const EventActionCardFragments = {
  TimelineCard: gql`
    fragment EventActionCardTimelineCard on TimelineCard {
      last_updated_date
      ...PlaceholderCard
      ...CounterpartyCard
      ...LoansCard
      ...StratsCard
      ...DealDocumentsCard
      ...CarveDetailsCard
      ...BidCard
      ...BiddingAndPricingControllerCard
      ...DiligenceCard
      ...SettlementCard
      ...WireConfirmationCard
    }
    ${PlaceholderCardFragments.TimelineCard}
    ${CounterpartyCardFragments.TimelineCard}
    ${LoansCardFragments.TimelineCard}
    ${StratsCardFragments.TimelineCard}
    ${DealDocumentsCardFragments.TimelineCard}
    ${CarveDetailsCardFragments.TimelineCard}
    ${BidCardFragments.TimelineCard}
    ${BiddingAndPricingControllerFragments.TimelineCard}
    ${DiligenceCardFragments.TimelineCard}
    ${SettlementCardFragments.TimelineCard}
    ${WireConfirmationCardFragments.TimelineCard}
  `,
};

export default EventActionCardFragments;
